const empty = () =>
  import(/* webpackChunkName: "empty" */ "../views/Empty.vue");

export default [
  {
    path: "statistics",
    name: "Statistics",
    component: empty,
    children: [
      {
        path: "user",
        name: "StatisticsUser",
        component: empty,
        meta: {
          title: "用户统计",
        },
        children: [
          {
            path: "student",
            name: "StatisticsStudent",
            component: () =>
              import(
                /* webpackChunkName: "statistics" */ "../views/statistics/StatisticsStudent"
              ),
            meta: {
              title: "学员列表",
              root: true,
            },
          },
          {
            path: "student-overview",
            name: "StudentOverview",
            component: () =>
              import(
                /* webpackChunkName: "statistics" */ "../views/statistics/StudentOverview"
              ),
            meta: {
              title: "学员统计",
              root: true,
            },
          },
          {
            path: "teacher",
            name: "StatisticsTeacher",
            component: () =>
              import(
                /* webpackChunkName: "statistics" */ "../views/statistics/StatisticsTeacher"
              ),
            meta: {
              title: "讲师统计",
              root: true,
            },
          },
        ],
      },
      {
        path: "res",
        name: "StatisticsRes",
        component: empty,
        meta: {
          title: "资源统计",
        },
        children: [
          {
            path: "course",
            name: "StatisticsCourse",
            component: () =>
              import(
                /* webpackChunkName: "statistics" */ "../views/statistics/StatisticsCourse"
              ),
            meta: {
              title: "课程统计",
              root: true,
            },
          },
        ],
      },
      {
        path: "order",
        name: "OrderStatistics",
        component: empty,
        meta: {
          title: "订单统计",
        },
        children: [
          {
            path: "order-overview",
            name: "OrderOverview",
            component: () =>
              import(
                /* webpackChunkName: "statistics" */ "../views/statistics/OrderOverview"
              ),
            meta: {
              title: "订单统计",
              root: true,
            },
          },
        ],
      },
    ],
  },
];
